export const googleMap = () => {
    const getCookie=n=>{
        const name=n+"=";
        return document.cookie.split(';').map(c=>c.trim()).find(c=>c.startsWith(name))?.substring(name.length)||null;
    };

    if(getCookie("cookie-maps") !== "true") {
        document.querySelectorAll(".bsk-map").forEach(item => {
            item.innerHTML = `<p class="bsk-map__placeholder-info p-3 text-center">Accept the cookies to see the Google Map:<br><button class="bsk-btn-1 mt-3 ho-cookies-btn-cookies-bar--trigger">Cookies Settings</button></p>`;
            if(item.nextElementSibling?.classList.contains("bsk-map-placeholder")) {
                console.log('xx:', item.nextElementSibling?.classList.contains("bsk-map-placeholder"));
                item.nextElementSibling?.classList.remove('d-none');
            }
        });
        return;
    }

    const API_KEY = document.querySelector(".ho-cookies-btn-cookies-bar")?.dataset.gmaps || "KEY_NOT_FOUND";
    // console.log("googleMapsKey: ", API_KEY);

    function loadScript() {
        if (window.google && window.google.maps) {
            initMap();
            return;
        }

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=initMap`;
        script.async = true;
        window.initMap = initMap;
        document.head.appendChild(script);
    }

    function initMap() {
        const el = document.querySelector(".bsk-map");
        if (!el) return;

        const center = { lat: 50.043114, lng: 19.9468822 };

        const sepiaStyles = [
            {
                stylers: [
                    { hue: "#e2c08d" },
                    { saturation: -40 },
                    { lightness: 10 },
                    { gamma: 0.8 }
                ]
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    { color: "#c9b494" }
                ]
            }
        ];

        const map = new google.maps.Map(el, {
            zoom: 15,
            center: center,
            styles: sepiaStyles
        });

        const marker = new google.maps.Marker({
            position: center,
            map: map,
            title: "Boxernia Serca Krakowa"
        });

        const infoWindow = new google.maps.InfoWindow({
            content: `
                <div class="p-3">
                    <p><strong>Boxernia Serca Krakowa</strong><br>Plac Niepodległości 1, Kraków</p> 
                </div>
            `,
        });

        const toggleInfoWindow = () => {
            if (window.innerWidth >= 960) {
                infoWindow.open(map, marker);
            } else {
                infoWindow.close();
            }
        };

        toggleInfoWindow();

        window.addEventListener('resize', () => {
            toggleInfoWindow();
        });

        marker.addListener("click", () => {
            infoWindow.open(map, marker);
        });
    }

    loadScript();
}
